import * as EserviceCommon from 'sos-eservice-common/js/components';
import 'sos-common/sass/style.scss'; //Common styles
import '../../sass/style.scss';

import { ResearchOrder } from '../containers/researchOrder/ResearchOrder';
import { StatisticsOrder } from '../containers/StatisticsOrder/StatisticsOrder';
import { QualityRegisterOrder } from '../containers/qualityRegisterOrder/QualityRegisterOrder';
import { OrderTypeChooser } from '../components/OrderTypeChooser/OrderTypeChooser';
import { FileUpload } from '../components/FileUpload/FileUpload';
import { FileDownload } from '../components/FileDownload/FileDownload';
import { CaseList } from '../components/CaseList/CaseList';

//common components
import { MainMenu } from 'sos-common/js/components/MainMenu/MainMenu';
import { SiteHeader } from 'sos-common/js/components/SiteHeader/SiteHeader';
import { BreadCrumbs } from 'sos-common/js/components/BreadCrumbs/BreadCrumbs';
import { Notification } from 'sos-common/js/components/Notification/Notification';
import { Hero } from 'sos-common/js/components/Hero/Hero';
import { TagList } from 'sos-common/js/components/TagList/TagList';
import { Lazyloader } from 'sos-common/js/components/Lazyloader/Lazyloader';
import { ShareWidget } from 'sos-common/js/components/ShareWidget/ShareWidget';
import { Search } from 'sos-common/js/components/Search/Search';
import { SearchList } from 'sos-common/js/components/SearchList/SearchList';
import { Fileupload } from 'sos-common/js/components/Fileupload/Fileupload';
import { TextInput } from 'sos-common/js/components/FormControls/TextInput';
import { CheckBox } from 'sos-common/js/components/FormControls/CheckBox';
import { CurrentEvent } from 'sos-common/js/components/CurrentEvent/CurrentEvent';
import { CurrentCalendar } from 'sos-common/js/components/CurrentCalendar/CurrentCalendar';
import { Icon } from 'sos-common/js/components/Icon/icon';
import { Tooltip } from 'sos-common/js/components/Tooltip/Tooltip';
import { DesktopLanguagePicker } from 'sos-common/js/components/DesktopLanguagePicker/DesktopLanguagePicker';
import { TreeView } from 'sos-common/js/components/SubNavigation/TreeView';
import { ActualListening } from 'sos-common/js/components/ActualListening/ActualListening';
import { AcceptConditions } from 'sos-common/js/components/AcceptConditions/AcceptConditions';
import { SureDelete } from 'sos-common/js/components/SureDelete/SureDelete';
import { CalendarPageList } from 'sos-common/js/components/CalendarPageList/CalendarPageList';
import { CalendarArchiveList } from 'sos-common/js/components/CalendarArchiveList/CalendarArchiveList';
import { VideoBlock } from 'sos-common/js/components/VideoBlock/VideoBlock';
import { CookieConsentManager } from 'sos-common/js/components/CookieConsentManager/CookieConsentManager';
import { LinkPuff } from 'sos-common/js/components/LinkPuff/LinkPuff';
import { TabComponent } from 'sos-common/js/components/TabComponent/TabComponent';
import { ExpanderGroup } from 'sos-common/js/components/ExpanderGroup/ExpanderGroup';
import { Analytics } from 'sos-common/js/components/Analytics/Analytics';
import { Dialog } from 'sos-common/js/components/Dialog/Dialog';

// const {
//     SiteHeader,
//     BreadCrumbs,
//     Notification,
//     Hero,
//     TagList,
//     Lazyloader,
//     ShareWidget,
//     Search,
//     SearchList,
//     Fileupload,
//     TextInput,
//     CheckBox,
//     CurrentEvent,
//     CurrentCalendar,
//     Icon,
//     Tooltip,
//     DesktopLanguagePicker,
//     TreeView,
//     ActualListening,
//     AcceptConditions,
//     SureDelete,
//     MainMenu,
//     VideoBlock,
//     CookieConsentManager,
//     Analytics,
//     LinkPuff,
//     CalendarPageList,
//     CalendarArchiveList,
//     TabComponent,
//     ExpanderGroup,
//     Dialog
// } = Common;

const { EServicesSiteHeader, EServiceFormMenu, SessionHandler } = EserviceCommon;

export {
    SiteHeader,
    EServicesSiteHeader,
    Hero,
    BreadCrumbs,
    Notification,
    TagList,
    Lazyloader,
    ShareWidget,
    Search,
    CurrentEvent,
    CurrentCalendar,
    SearchList,
    Fileupload,
    Icon,
    TextInput,
    CheckBox,
    Tooltip,
    DesktopLanguagePicker,
    TreeView,
    ActualListening,
    OrderTypeChooser,
    AcceptConditions,
    SureDelete,
    EServiceFormMenu,
    ResearchOrder,
    StatisticsOrder,
    QualityRegisterOrder,
    MainMenu,
    VideoBlock,
    CookieConsentManager,
    LinkPuff,
    CalendarPageList,
    CalendarArchiveList,
    TabComponent,
    ExpanderGroup,
    FileUpload,
    FileDownload,
    CaseList,
    Dialog,
    Analytics
};
